const reports = {
	title: "Rapporter",
	select_report: "Velg rapport",
	select_year: "Velg år",
	select_tenant: "Velg klient",
	select_organisation: "Velg organisasjon",
	report_sms_usage: "SMS forbruk",
	report_organisation_tenant: "Organisasjonsklienter",
	report_usage_report: "Usage report",
	report_number_completed_courses: "Number of completed courses",
	report_number_of_expertise: "Number of expertise added for students",
	students: "Elever",
	users: "Brukere",
	active_users: "Aktive brukere",
	storage_used: "Brukt plass",
	count: "Antall",
	year: "År",
};
export default reports;